<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-6">
        <a @click="openPage('/ptSessionBuy')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
      </div>
    </div>
    <div class="box">
      <div class="p-20">
        <form @submit.prevent="validatePtSession('ptSession')" data-vv-scope="ptSession">
          <div class="row justify-content-center mt-30">
            <div class="col-sm-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Member ID</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select disabled @change="getMemberData" class="border-bottom" name="member_id"
                    v-validate="'required'" v-model="addData.member_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataMember" :key="item.id" :value="item.id">
                      <template v-if="item.branch">{{ item.branch.codename }}</template><template
                        v-else>XX</template>-{{ item.id }}
                    </option>
                  </b-form-select>
                  <span class="error">{{ errors.first('ptSession.member_id') }}</span>
                </b-col>
              </b-row>
              <b-row v-if="countAvailForNewMember != 1" class="mb-20">
                <b-col sm="3">
                  <label>New Member</label>
                </b-col>
                <b-col sm="9">
                  <div class="custom-search-select">
                    <multi-select :options="optionAddNewMember" :selected-options="items" placeholder="Select member"
                      :selectedItems="items" name="new_member_id" :isDisabled=true @select="onSelect">
                    </multi-select>
                  </div>
                  <!-- <span class="error">Max {{countAvailForNewMember}} member.</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Member Name</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom" disabled v-model="fullName" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Phone Number</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom" disabled v-model="detailMember.phone_number"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Email</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom" disabled v-model="detailMember.email" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Membership Type</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom" disabled v-model="detailMember.membership_last_buy_name"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Join Date</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom" disabled v-model="detailMember.start_membership"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Employee ID</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select disabled @change="getCSData" class="border-bottom" name="customer_service_id"
                    v-validate="'required'" v-model="addData.customer_service_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataCS" :key="item.id" :value="item.id">
                      <template v-if="item.branch">{{ item.branch.codename }}</template><template
                        v-else>XX</template>-{{ item.id }}
                    </option>
                  </b-form-select>
                  <span class="error">{{ errors.first('customer_service_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Customer Service Name</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom" disabled v-model="CSName" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-sm-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Seller</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select disabled class="border-bottom" name="seller" v-validate="'required'"
                    v-model="addData.sales_id">
                    <option :value="null">Please select</option>
                    <option :value="0">Personal Trainer</option>
                    <option v-for="item in itemSales" :key="item.id" :value="item.id">
                      Sales - {{ item.fullname }}
                    </option>
                  </b-form-select>
                  <span class="error">{{ errors.first('ptSession.seller') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Branch</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="branch" v-model="addData.branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Personal Trainer</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select @change="filterPtSession" class="border-bottom" name="personal_trainer"
                    v-validate="'required'" v-model="addData.personal_trainer_id">
                    <option :value="null">Please select</option>
                    <option v-for="listItem in itemPt" :key="listItem.id" :value="listItem.id">{{ listItem.name }}
                    </option>
                  </b-form-select>
                  <span class="error">{{ errors.first('ptSession.personal_trainer') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>PT Session</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select @change="getPtSessionData" class="border-bottom" name="personal_trainer"
                    v-validate="'required'" v-model="addData.pt_session_id">
                    <option :value="null">Please select</option>
                    <option v-for="itemSession in itemPtSession" :key="itemSession.id" :value="itemSession.id">
                      {{ itemSession.name }}
                    </option>
                  </b-form-select>
                  <span class="error">{{ errors.first('ptSession.personal_trainer') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label for="address">Is PTService</label>
                </b-col>
                <b-col sm="9">
                  <toggle-button v-model="is_pt_service" name="is_pt_service" :sync="true" />
                  <span class="error">{{ errors.first('is_pt_service') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>PT Session Quantity</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom" disabled v-model="detailPtSession.quantity"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>PT Session Price</label>
                </b-col>
                <b-col sm="9">
                  <!-- <b-form-input class="border-bottom" disabled v-model="detailPtSession.price" type="text"></b-form-input> -->
                  <money class="form-control border-bottom" v-model="detailPtSession.price" v-bind="money2" disabled>
                  </money>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Voucher</label>
                </b-col>
                <b-col sm="9">
                  <!-- <b-form-input class="border-bottom" disabled v-model="detailPtSession.price" type="text"></b-form-input> -->
                  <money class="form-control border-bottom" v-model="voucher_amount" v-bind="money2" disabled></money>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Gross Amount</label>
                </b-col>
                <b-col sm="9">
                  <money class="form-control border-bottom" v-model="addData.gross_amount" :value="totalPayment"
                    v-bind="money2" disabled></money>
                  <!-- <b-form-input class="border-bottom" disabled name="gross_amount" v-validate="'required|numeric'" :value="totalPayment" v-model="addData.gross_amount" type="text"></b-form-input> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Total Payment</label>
                </b-col>
                <b-col sm="9">
                  <money class="form-control border-bottom" v-model="total_bayar" v-bind="money2" disabled></money>
                  <!-- <b-form-input class="border-bottom" disabled name="gross_amount" v-validate="'required|numeric'" :value="totalPayment" v-model="addData.gross_amount" type="text"></b-form-input> -->
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="text-right">
            <button :disabled="disableBtnSubmit" type="submit" class="btn-primary">Submit</button>
            <!-- <b-modal class="modal-custom-privy" hide-footer v-model="modalShow" centered title="Checkout">
              <div class="container-iframe">
                <iframe id="paymentFrame" v-show="linkPrivyId" :src="linkPrivyId" class="w-100" frameborder="0"></iframe>
              </div>
            </b-modal> -->
          </div>
        </form>
      </div>
    </div>

    <!-- loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { MultiSelect } from 'vue-search-select'

export default {
  name: 'addbranch',
  components: {
    MultiSelect
  },
  data: function () {
    return {
      loadingActive: false,
      disableBtnSubmit: false,
      errorMoney: 'The amount field is required!',
      optionAddNewMember: [],
      countAvailForNewMember: 1, // if qty > 1 then show new member
      searchText: '', // If value is falsy, reset searchText & searchItem
      items: [],
      lastSelectItem: {},
      dataMember: [],
      dataBranch: [],
      dataCS: [],
      config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      is_pt_service: false,
      itemSales: [],
      itemPt: [],
      itemPtSession: [],
      itemsPaymentCard: [],
      itemsPaymentType: [],
      detailMember: {},
      detailPtSession: {},
      detailCS: {},
      fullName: '',
      CSName: '',
      // modalShow: false,
      linkPrivyId: '',
      amountPaymentCard1: '',
      amountPaymentCard2: '',
      editData: {
        customer_service_id: null,
        personal_trainer_id: null,
        is_pt_service: 0
      },
      addData: {
        branch_id: null,
        customer_service_id: null,
        member_id: null,
        new_member_id: [],
        sales_id: null,
        personal_trainer_id: null,
        gross_amount: '',
        transaction_type_id: 5,
        pt_session_id: null,
        payment_type_id_1: null,
        payment_card_id_1: null,
        payment_amount_1: '',
        payment_type_id_2: null,
        payment_card_id_2: null,
        payment_amount_2: ''
      },
      voucher_amount: 0,
      total_bayar: 0,
      listDataPtSession: [],
      addDataPrivy: {
        member_id: null,
        customer_id: null,
        branch_id: null,
        trx_id: '',
        doc_name: 'personal_trainer.hbs'
      },
      getTierData: '',
      linkDataPrivy: ''
    }
  },
  methods: {
    onSelect(items, lastSelectItem) {

      if (this.items.length >= this.countAvailForNewMember) {
        // this.items = []
        // this.addData.new_member_id = []
        this.$toast.success("Max " + this.countAvailForNewMember + " for new member ", "Error", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });
      } else {
        this.items = items
        this.lastSelectItem = lastSelectItem
        var new_member_id = this.addData.new_member_id.find((e) => e == lastSelectItem.value)
        if (!new_member_id) {
          this.addData.new_member_id.push(lastSelectItem.value)
        } else {
          var arr = this.addData.new_member_id.filter((e) => e != lastSelectItem.value)
          this.addData.new_member_id = arr
        }
      }
      // console.log(this.addData.new_member_id);
    },
    // deselect option
    reset() {
      this.items = [] // reset
    },
    // select option from parent component
    selectFromParentComponent() {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual)
    },
    filterPtSession(event) {
      if (event != null) {
        this.addData.pt_session_id = null
        this.detailPtSession.quantity = 0
        this.detailPtSession.price = 0
        this.addData.gross_amount = 0
        axios.get('fitness/v1/personal_training/' + event).then(response => {
          // console.log(response.data.data.pt_tier)
          this.changeDataTier(response.data.data.pt_tier)
        }).catch(error => {
          console.log('error', error)
        })
      } else {
        this.addData.pt_session_id = null
        this.detailPtSession.quantity = 0
        this.detailPtSession.price = 0
        this.addData.gross_amount = 0
        this.changeDataTier('')
      }
    },
    changeDataTier(event) {
      axios.get('fitness/v1/pt_session?pt_tier=' + event + '&sorting=name&sorting_type=asc').then(response => {
        this.itemPtSession = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    getCSData(event) {
      axios.get('crm/v1/customer_service/' + event).then(response => {
        this.detailCS = response.data.data
        this.CSName = response.data.data.name
        this.addDataPrivy.customer_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    changePaymentType1(event) {
      if (event === 1 || event === 6) {
        this.addData.payment_card_id_1 = null
      }
    },
    changePaymentType2(event) {
      if (event === 1 || event === 6) {
        this.addData.payment_card_id_2 = null
      }
    },
    getMemberData(event) {
      axios.get('fitness/v1/member/' + event).then(response => {
        this.detailMember = response.data.data
        this.fullName = response.data.data.first_name + ' ' + response.data.data.last_name
        this.addDataPrivy.branch_id = response.data.data.branch_id
        this.addDataPrivy.member_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    getPtSessionData(event) {
      axios.get('fitness/v1/pt_session/' + event).then(response => {
        this.items = []
        this.countAvailForNewMember = 1
        this.detailPtSession = response.data.data
        // console.log('test', response.data.data)
        this.addData.gross_amount = response.data.data.quantity * response.data.data.price

        this.total_bayar = this.addData.gross_amount - this.voucher_amount

        if (response.data.data.group_member_qty != 1) {
          this.countAvailForNewMember = response.data.data.group_member_qty;
        }
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    formSelect(event) {
      return event
    },
    changeValueMoney(event) {
      if (!(event.key === '')) {
        this.$refs['error-print'].classList.add('hidden')
      } else {
        this.$refs['error-print'].classList.remove('hidden')
      }
    },
    validatePtSession(data1) {
      this.$validator.validateAll(data1).then(async result => {
        if (result) {
          // var baseUrl = window.location.origin
          // this.linkDataPrivy = window.open(baseUrl + '/loading')
          // this.addData.payment_amount_1 = this.amountPaymentCard1
          // this.addData.payment_amount_2 = this.amountPaymentCard2
          // this.editData.customer_service_id = this.addData.customer_service_id
          this.editData.personal_trainer_id = this.addData.personal_trainer_id
          this.editData.is_pt_service = this.is_pt_service ? 1 : 0

          // console.log('Save Data: ', this.editData)

          this.$swal({
            title: 'Are you sure?',
            text: 'You are about to submit this Buying Session data and waiting for approval',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Submit now!',
            cancelButtonText: 'No, Cancel it!',
            showCloseButton: true,
            showLoaderOnConfirm: false
          }).then((confirm) => {
            if (confirm.value) {
              const payload = {
                entity_id: this.$route.query.id,
                request_data: this.editData,
                action: 'EDIT',
                notes: 'Update Buy Session',
                module_type: 'BUYPTSESSION',
                description: `Edit Buy PTSession with ID ${this.$route.query.id} | Member: ${this.addData.member_id}-${this.fullName} | PT Session: ${this.detailPtSession.name}`,
              }

              this.loadingActive = true
              // add to approval request
              axios.post('/crm/v1/approval_request/get_aprroval', payload).then(response => {
                this.loadingActive = false
                this.$swal('Successfully!', 'Data has been submitted and waiting for approval!', 'success')
                this.fetchData()
              }).catch((error) => {
                this.loadingActive = false
                console.log('Error', error)
                this.$swal('Failed!', 'Data has been waiting for approval!', 'error')
              })
            }
          })

          // try{
          //   const updatePtSession = await axios.put('fitness/v1/pt_session_transaction/' + this.$route.query.id, this.editData)
          //   // this.addDataPrivy.trx_id = updatePtSession.data.data.id
          //   this.$router.push('/ptSessionBuy')
          //   this.$toast.success('data saved successfully!', 'Success', {
          //     position: 'topCenter',
          //     icon: 'icon-envelope',
          //     progressBarColor: 'rgb(0, 255, 184)',
          //     theme: 'dark',
          //     backgroundColor: '#565c70',
          //     messageColor: '#fff'
          //   })
          // } catch(error){
          //   console.log('error', error)
          //   this.$toast.success('cant saved data!', 'Error', {
          //     position: 'topCenter',
          //     icon: 'icon-envelope',
          //     progressBarColor: 'rgb(0, 255, 184)',
          //     theme: 'dark',
          //     backgroundColor: '#565c70',
          //     messageColor: '#fff'
          //   })
          // }
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    changeBranch(event) {
      this.addData.personal_trainer_id = null
      axios.get('fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc&branch_id=' + event).then(response => {
        this.itemPt = response.data.data.rows;
      }).catch(error => {
        console.log('error', error)
      })
    },
    openPage(event) {
      this.$router.push(event)
    },
    fetchData() {
      // this.addData.customer_service_id = Auth.Session.get().paradigm_id
      axios.get('fitness/v1/member/data_entry').then(response => {
        this.dataMember = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('transaction/v1/payment_card?sorting=id&sorting_type=asc').then(response => {
        this.itemsPaymentCard = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('transaction/v1/payment_type').then(response => {
        this.itemsPaymentType = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/sales/').then(response => {
        this.itemSales = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/pt_session?sorting=name&sorting_type=asc').then(response => {
        this.itemPtSession = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/customer_service/').then(response => {
        this.dataCS = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      this.loadingActive = true
      axios.get('fitness/v1/pt_session_transaction/' + this.$route.query.id).then(response => {
        this.loadingActive = false
        // this.listDataPtSession = response.data.data
        this.addData.member_id = response.data.data.member_id
        this.addData.branch_id = response.data.data.branch_id
        this.addData.customer_service_id = response.data.data.customer_service_id
        this.addData.sales_id = response.data.data.sales_id
        this.addData.personal_trainer_id = response.data.data.personal_trainer_id
        this.addData.pt_session_id = response.data.data.pt_session_id
        this.voucher_amount = response.data.data.voucher_amount

        // this.total_bayar = parseInt(response.data.data.gross_amount) - parseInt(response.data.data.voucher_amount)

        const year = moment(response.data.data.created_at).format('YYYY')
        const month = moment(response.data.data.created_at).format('M')

        axios.get('crm/v1/closing_period/member_pt_session?year=' + year + '&bulan=' + month).then(result => {
          console.log(result)
          this.disableBtnSubmit = true
        }).catch(error => {
          console.log('error', error)
        })


        this.getMemberData(response.data.data.member_id)
        this.getCSData(response.data.data.customer_service_id)
        this.getPtSessionData(response.data.data.member_pt_session.pt_session_id)
        this.getListNewMember(response.data.data.member_pt_session.id)

        axios.get('fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc&branch_id=' + this.addData.branch_id).then(response => {
          this.itemPt = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })

      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    getListNewMember(pt_session_id) {
      axios.get('fitness/v1/member_pt_session/member_pt_session_group/' + pt_session_id).then(res => {
        // console.log(res)
        let data = res.data.data
        setTimeout(() => {
          for (let i = 0; i < data.length; i++) {
            // this.items.push({ value: data[i].member.id, text: data[i].member.first_name + " " + data[i].member.last_name})
            this.items.push({ value: data[i].member.id, text: data[i].member.first_name + " " + data[i].member.last_name })
          }
        }, 2000);
      }).catch(error => {
        console.log('error', error)
      })

    },

  },
  computed: {
    totalPayment: function () {
      let calculatedTotal = this.addData.gross_amount
      this.amountPaymentCard1 = this.addData.gross_amount
      return calculatedTotal
    },
    paymentLeft: function () {
      if (String(this.amountPaymentCard1).length > String(this.addData.gross_amount).length) {
        console.log('test')
        this.amountPaymentCard2 = 0
      } else {
        this.amountPaymentCard2 = this.addData.gross_amount - this.amountPaymentCard1
        this.amountPaymentCard2 = Math.abs(this.amountPaymentCard2)
      }
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style></style>
